import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 20px;
  padding: 6px 20px 0px 20px;
`

export const ImagePreviewContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 4px;
`

export const Title = styled.h1`
  font-size: 14px;
  font-weight: 500;
  color: #585353;
  font-family: Roboto;
`

export const BillboardImagePreview = styled.img`
  width: 397px;
  height: 64px;
  object-fit: cover;
  object-position: center;
`

export const BannerContainer = styled.div`
  position: relative;
  display: inline-block;
`

export const BillboardBorder = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 75px;
    background: rgba(0, 0, 0, 0.3);
  }

  &::before {
    left: 0;
  }

  &::after {
    right: 0;
  }
`

export const BillboardSafeArea = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 247px;
  height: 63px;
  border: 2px dashed #d50000;
  pointer-events: none;
`

export const CompactImagePreview = styled(BillboardImagePreview)`
  width: 397px;
  height: 39px;
`

export const CompactBorder = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 74px;
    background: rgba(0, 0, 0, 0.3);
  }

  &::before {
    left: 0;
  }

  &::after {
    right: 0;
  }
`

export const CompactSafeArea = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 248px;
  height: 39px;
  border: 2px dashed #d50000;
  pointer-events: none;
`

export const MediumImagePreview = styled(BillboardImagePreview)`
  width: 397px;
  height: 194px;
`

export const MediumBorder = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 82px;
    background: rgba(0, 0, 0, 0.3);
  }

  &::before {
    left: 0;
  }

  &::after {
    right: 0;
  }
`

export const MediumSafeArea = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 232px;
  height: 193px;
  border: 2px dashed #d50000;
  pointer-events: none;
`

export const DownloadContainer = styled.div`
  width: 100%;
  border-radius: 5px;
  border: 1px solid #dfdfdf;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 24px;
  gap: 16px;
`

export const LightbulbIcon = styled.img.attrs({
  src: 'images/lightbulb.svg',
})``

export const DownloadText = styled.p`
  font-size: 12px;
  font-weight: 400;
  color: #8b8b8b;
  font-family: Roboto;
  margin: 0;
  line-height: normal;
  white-space: pre-line;

  a {
    color: #6196e1;
    text-decoration: underline;
  }
`
